import { ActivityWorkflowState } from '@/api/models/aggregate'
import { isAvailable } from '@/hooks/useActivityParts/helpers/isAvailable'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const findActiveActivityPart = (
  activityWithAggregate: FrontActivityWithAggregate,
  findDeep = false,
): FrontActivityPart<FrontActivityWithAggregate> | null => {
  return _findActiveActivity(activityWithAggregate.children, findDeep)
}

export const _findActiveActivity = (
  activityParts: FrontActivityPart<FrontActivityWithAggregate>[],
  findDeep = false,
): FrontActivityPart<FrontActivityWithAggregate> | null => {
  let firstAvailable: FrontActivityPart<FrontActivityWithAggregate> | null = null

  for (let i = 0, len = activityParts.length; i < len; i++) {
    const activityPart = activityParts[i]

    // Skip unavailable parts
    if (!isAvailable(activityPart)) continue

    if (!firstAvailable) firstAvailable = activityPart

    const activityWithAggregate = activityPart.childActivity
    const lastActivityWorkflow = activityWithAggregate.activityWorkflowAggregate?.lastActivityWorkflow
    const state = lastActivityWorkflow?.state
    const children = activityWithAggregate.children
    const hasChildren = children.length > 0

    // Check if in progress or not started
    if (state === ActivityWorkflowState.inProgress || !lastActivityWorkflow) {
      if (!findDeep || !hasChildren) {
        return activityPart // Immediate result found
      }

      // Check nested activities
      const nestedFirst = _findActiveActivity(children, findDeep)
      if (nestedFirst) return nestedFirst
    }
  }

  return firstAvailable
}
